import React from "react";
import { ModalHeader } from "reactstrap";
import PropTypes from "prop-types";
import Button from "../UIButton/UIButton"; // your reusable UIButton

export default function ActionModalHeader({
    title,
    onCancel,
    cancelButtonDisabled = false,
    cancelText = "Cancel",
    actionButton, // JSX: e.g. <UIButton variant="submit">Save</UIButton>
    className = "",
}) {
    return (
        <ModalHeader
            className={`d-flex justify-content-between align-items-center location-modal-header p-3 ${className}`}
        >
            <span className="fw-bold left-align text-primary ml-4">{title}</span>
            <div className="right-align">
                <Button
                    id="cancelButton"
                    variant="info"
                    size="medium"
                    onClick={onCancel}
                    disabled={cancelButtonDisabled}
                    className="me-2"
                >
                    {cancelText}
                </Button>
                {actionButton}
            </div>
        </ModalHeader>
    );
}

ActionModalHeader.propTypes = {
    title: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    cancelButtonDisabled: PropTypes.bool,
    cancelText: PropTypes.string,
    actionButton: PropTypes.node.isRequired,
    className: PropTypes.string,
};
